import { render } from "./metfone-notify.vue?vue&type=template&id=ca71013a"
import script from "./metfone-notify.vue?vue&type=script&lang=js"
export * from "./metfone-notify.vue?vue&type=script&lang=js"

import "./metfone-notify.vue?vue&type=style&index=0&id=ca71013a&lang=css"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__